import React from "react";
import { ColorSwatch, Flex, Paper, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { LikeResponse } from "../../../entities/components/LikeResponse";
import useReportStore from "../../../store/useReportStore";
import "../Report.scss";

const COLORS = ["#05D8D2", "#A64DD7", "#6F40E2", "#3A8BD9"];

export const DataAnalysisSkills: React.FC = () => {
  const { report, reportId } = useReportStore();
  const roadmapSkills = report?.skills_to_master_switch_role?.mark_down
    ? report?.skills_to_master_switch_role
    : report?.skills_to_master_higher_role?.mark_down
    ? report.skills_to_master_higher_role
    : null;

  const matches = useMediaQuery("(max-width: 1100px)");
  const mobile = useMediaQuery("(max-width: 850px)");

  return (
    <Paper radius="24px" p="32px" mt={32} withBorder>
      <Title size={matches ? 24 : 36} mb={8}>
        {roadmapSkills?.mark_down
          ? roadmapSkills?.mark_down?.replace("##", "")
          : ""}
      </Title>
      <Text style={{ fontSize: matches ? 16 : 18 }} mb={24} c="dimmed">
        {roadmapSkills ? roadmapSkills?.explanation : ""}
      </Text>
      <Flex c="#fff" gap={matches ? 22 : 64} pos="relative">
        {!matches && (
          <>
            <div className="v-line" />
            <div className="h-line h-line-1" />
            <div className="h-line h-line-2" />
            <div className="h-line h-line-3" />
            <div className="h-line h-line-4" />
          </>
        )}
        <Flex direction="column" gap={matches ? 22 : 40} w="50%">
          {roadmapSkills?.data.slice(0, 2).map((item, index) => (
            <Paper
              key={index}
              radius="16px"
              p={matches ? 12 : 24}
              bg={COLORS[index % COLORS.length]}
              mih={mobile ? 128 : 226}
              style={{ zIndex: 3 - index }}
            >
              <Title size={mobile ? 16 : 24} mb={16}>
                {item.title}
              </Title>
              {!mobile && (
                <Text size={matches ? "m" : "lg"}>{item.description}</Text>
              )}
            </Paper>
          ))}
        </Flex>
        <Flex
          direction="column"
          gap={matches ? 22 : 40}
          mt={mobile ? 0 : "12.5%"}
          mb={mobile ? 24 : undefined}
          w="50%"
        >
          {roadmapSkills?.data.slice(2, 4).map((item, index) => (
            <Paper
              key={index}
              radius="16px"
              p={matches ? 12 : 24}
              bg={COLORS[(index + 2) % COLORS.length]}
              mih={mobile ? 128 : 226}
            >
              <Title size={mobile ? 16 : 24} mb={16}>
                {item.title}
              </Title>
              {!mobile && (
                <Text size={matches ? "m" : "lg"}>{item.description}</Text>
              )}
            </Paper>
          ))}
        </Flex>
      </Flex>
      {mobile &&
        roadmapSkills?.data.map((item, index) => (
          <Flex key={index} gap={5} mt={16}>
            <ColorSwatch
              color={COLORS[index % COLORS.length]}
              size={14}
              radius={2}
              mt={5}
            />
            <Text>
              <b>{item.title}</b>: {item.description}
            </Text>
          </Flex>
        ))}
      <LikeResponse
        report_id={reportId!}
        section="roadmap_skills_to_master_switch_role"
      />
    </Paper>
  );
};
